import React from 'react'

import './Page.css'


export default function Pgae() {
  return (
    <>
    <div className='spn'>

   
   <div class="spinner">
    <div class="spinner1"></div>
   </div>

   </div>
    </>
  )
}
